import { render, staticRenderFns } from "./TeacherRegister.vue?vue&type=template&id=540a4ce6&scoped=true"
import script from "./TeacherRegister.vue?vue&type=script&lang=js"
export * from "./TeacherRegister.vue?vue&type=script&lang=js"
import style0 from "./TeacherRegister.vue?vue&type=style&index=0&id=540a4ce6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a4ce6",
  null
  
)

export default component.exports